export class GridChameleonManagerState {
    static grid;
    static state;
    static load(grid, state) {
        this.grid = grid;
        this.state = state ?? {};
        this.state.Columns = this.state.Columns ?? [];
        this.loadLocal();
        this.apply();
    }
    static setColumnSort(columnId, sortDirection) {
        this.state.SortColumnName = columnId;
        this.state.SortDirection = sortDirection;
    }
    static setColumnHidden(columnId, hidden) {
        this.getColumn(columnId).Hidden = hidden;
        this.saveLocal();
    }
    static setColumnSize(columnId, size) {
        this.getColumn(columnId).Size = size;
        this.saveLocal();
    }
    static setColumnFreeze(columnId, freeze) {
        this.getColumn(columnId).Freeze = freeze;
        this.saveLocal();
    }
    static setColumnOrder(columnId, order) {
        this.getColumn(columnId).Order = order;
        this.saveLocal();
    }
    static setColumnFilterEqual(columnId, value) {
        this.getColumnFilter(columnId).Equal = value;
        this.updateIsFiltering(columnId);
    }
    static setColumnFilterLess(columnId, value) {
        this.getColumnFilter(columnId).Less = value;
        this.updateIsFiltering(columnId);
    }
    static setColumnFilterGreater(columnId, value) {
        this.getColumnFilter(columnId).Greater = value;
        this.updateIsFiltering(columnId);
    }
    static apply() {
        const sortColumn = this.grid.getColumnByHtmlName((this.state.SortColumnName ?? "").toUpperCase());
        if (sortColumn) {
            sortColumn.SortDirection = this.state.SortDirection;
        }
        this.state.Columns?.forEach(stateColumn => {
            const column = this.grid.getColumnByHtmlName(stateColumn.Name.toUpperCase());
            if (column) {
                if (typeof stateColumn.Hidden === "boolean") {
                    column.Hidden = stateColumn.Hidden ? -1 : 0;
                }
                if (stateColumn.Size) {
                    column.Size = "length";
                    column.SizeLength = stateColumn.Size;
                }
                if (stateColumn.Order) {
                    column.order = stateColumn.Order;
                }
                column.filterEqual =
                    (stateColumn.Filter ?? {}).Equal ?? column.filterEqual;
                column.filterLess =
                    (stateColumn.Filter ?? {}).Less ?? column.filterLess;
                column.filterGreater =
                    (stateColumn.Filter ?? {}).Greater ?? column.filterGreater;
                this.updateIsFiltering(column.htmlName);
            }
        });
    }
    static loadLocal() {
        this.grid.columns.forEach(column => {
            const columnSettings = localStorage
                .getItem(`${this.grid.ControlName}-${column.htmlName}`)
                ?.split("|");
            if (columnSettings) {
                if (columnSettings[0] !== "") {
                    this.getColumn(column.htmlName).Hidden = columnSettings[0] === "true";
                }
                if (columnSettings[1] !== "") {
                    this.getColumn(column.htmlName).Size = columnSettings[1];
                }
                if (columnSettings[2] !== "") {
                    this.getColumn(column.htmlName).Order = parseInt(columnSettings[2]);
                }
                if (columnSettings[3] !== "") {
                    this.getColumn(column.htmlName).Freeze = columnSettings[3];
                }
            }
        });
    }
    static saveLocal() {
        this.state.Columns.forEach(column => {
            localStorage.setItem(`${this.grid.ControlName}-${column.Name}`, [column.Hidden, column.Size, column.Order, column.Freeze].join("|"));
        });
    }
    static getColumn(name) {
        let column = this.state.Columns.find(column => column.Name.localeCompare(name) === 0);
        if (!column) {
            column = {
                Name: name
            };
            this.state.Columns.push(column);
        }
        return column;
    }
    static getColumnFilter(name) {
        const column = this.getColumn(name);
        if (!column.Filter) {
            column.Filter = {};
        }
        return column.Filter;
    }
    static updateIsFiltering(columnId) {
        const column = this.grid.getColumnByHtmlName(columnId);
        column.isFiltering = !!(column.filterEqual ||
            column.filterGreater ||
            column.filterGreater);
    }
}
//# sourceMappingURL=gx-grid-chameleon-state.js.map
